export default {
  home: {
    missing_order_no: '缺少订单号',
    order_load_failed: '订单信息加载失败：'
  },
  wallet: {
    loading: '正在加载...',
    no_available_wallet: '当前浏览器没有可用的 {wallet}。',
    apple_pay_fallback: '需要 Safari + Apple Wallet 可用卡 + HTTPS；线上还需要在 Stripe Dashboard 完成 Apple Pay 域名验证。',
    google_pay_fallback: '需要 Chrome + Google Pay 可用账号/卡 + HTTPS；线上请确认 Stripe Dashboard 已启用 Google Pay。',
    cashapp_pay_fallback: '请确认 Stripe Dashboard 已启用 Cash App Pay，且当前地区/账号支持该支付方式。',
    default_fallback: '线上请确认 Stripe Dashboard 已启用对应支付方式，并使用真实 HTTPS 域名。',
    init_failed: '初始化失败：',
    missing_order_no: '缺少订单号',
    creating_stripe_session: '正在创建 Stripe 支付会话...',
    backend_missing_keys: '后端未返回 publishableKey 或 clientSecret',
    payment_component_load_failed: '支付组件加载失败',
    payment_canceled: '已取消支付',
    confirming_payment: '正在确认支付...',
    payment_confirm_no_result: '支付确认未返回结果',
    redirecting_cashapp: '正在跳转 Cash App Pay...',
    payment_failed: '支付失败：',
    opening_cashapp_auth: '正在打开 Cash App 授权页面...',
    cashapp_auth_failed: 'Cash App 授权失败：'
  },
  return: {
    payment_success: '支付成功',
    processing: '处理中...',
    requires_action: '等待用户操作',
    payment_incomplete_or_canceled: '支付未完成或被取消',
    payment_canceled: '支付已取消',
    showing_payment_result: '正在展示支付结果...',
    status_label: '状态：'
  }
}
